<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction" :customHandleSearch="customHandleSearch"></toolbar>

    <!--列表-->
    <el-table
      :data="checks"
      border
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" label="序号" width="80"> </el-table-column>
      <el-table-column prop="Name" label="考核名称" width="300" sortable>
      </el-table-column>
      <!-- <el-table-column
        prop="HospitalCode"
        label="医疗机构编码"
        width=""
        sortable
      >
      </el-table-column> -->
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        width=""
        sortable
      >
      </el-table-column>
      <el-table-column prop="CreateBy" label="创建者" width="" sortable>
      </el-table-column>
      <el-table-column prop="IsEnable" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.IsEnable ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.IsEnable ? "正常" : "禁用" }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="150">
                <template scope="scope">
                    <el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column> -->
    </el-table>

    <!--工具条-->
    <!-- <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total"
        style="float: right">
      </el-pagination>
    </el-col> -->
    <el-pagination
      class="toolbar"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <!-- 新增 -->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      style="width: 900px; margin: 0 auto;"
      :destroy-on-close="true"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="考核名称" prop="Name">
          <el-input style="width: 300px" v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="Type">
          <el-select style="width: 300px;" v-model="addForm.Type" placeholder="请选择类型">
            <el-option
              v-for="item in checkTypeList"
              :key="item.ItemValue"
              :label="item.ItemText"
              :value="item.ItemValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="排序" prop="SortId">
          <el-input style="width: 150px"  v-model="addForm.SortId" auto-complete="off"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="状态" prop="IsEnable">
          <el-select style="width: 300px;" v-model="addForm.IsEnable" placeholder="请选择状态">
            <el-option label="激活" value="true"></el-option>
            <el-option label="禁用" value="false"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      style="width: 900px; margin: 0 auto;"
      :destroy-on-close="true"
    >
      <el-form :model="editForm" label-width="80px" ref="editForm" :rules="addFormRules">
        <el-form-item label="考核名称" prop="Name">
          <el-input style="width: 300px;" v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="排序" prop="SortId">
          <el-input v-model="editForm.SortId" auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="类型" prop="Type">
          <el-select style="width: 300px;" v-model="editForm.Type" placeholder="请选择类型">
            <el-option
              v-for="item in checkTypeList"
              :key="item.ItemValue"
              :label="item.ItemText"
              :value="item.ItemValue"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="状态" prop="IsEnable">
          <el-select style="width: 300px;" v-model="editForm.IsEnable" placeholder="请选择状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetCheck,
  DeleteCheckByIds,
  AddCheck,
  PutCheck,
} from "../../api/RatingManage/RatingManage";
import{
  GetSysDictByCode,
} from "../../api/SysDictionary/SysDictionary";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: "",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      checkTypeList:[],
      Name: "",
      checks: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      pageSize: 10,
      listLoading: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      sels: [], //列表选中列
      addFormVisible: false, //新增界面是否显示
      addLoading: false,

      addFormRules: {
        Name: [
          { required: true, message: "请输入考核名", trigger: "blur" },
          { max: 20, message: '考核名不能超过255个字符', trigger: 'blur' }
        ],
        Type: [{ required: true, message: "请选择考核类型", trigger: "blur" }],
        IsEnable: [{ required: true, message: "请选择考核状态", trigger: "blur" }],
      },

      //新增界面数据
      addForm: {
        Name: "",
        SortId: 0,
      },
      //编辑界面数据
      editForm: {},
    };
  },
  computed: {},
  methods: {
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.CreateTime),
            "yyyy-MM-dd hh:mm:ss"
          );
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getCheckLs();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1; // 当更改分页大小时，重置为第一页
      this.getCheckLs();
    },
    //获取检查类型字典
    getCheckTypes(){
      let para = {
        code: "Check_Type",
      };
      GetSysDictByCode(para).then((res) => {
        this.checkTypeList = res.data.response;
        //NProgress.done();
      });
    },
    //获取考核表信息
    getCheckLs() {
      let para = {
        page: this.page,
        key: this.filters.name,
        pageSize: this.pageSize,
      };
      this.listLoading = true;
      GetCheck(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.checks = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    customHandleSearch(val){
      this.filters = {
        name: val,
      };
      this.getCheckLs();
    },
    //显示新增/编辑界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Name: "",
        SortId: 0,
        IsEnable:true,
      };
    },
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //新增考核表信息
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            AddCheck(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              this.addLoading = false;
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                // this.$refs.table.setCurrentRow();
                this.addFormVisible = false;
                this.getCheckLs();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //删除考核表信息
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("该操作会同步删除下属考核模块、考核项，确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = [row.Id];
          DeleteCheckByIds(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.currentRow = null;
              this.$refs.table.clearSelection();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.getCheckLs();
          });
        })
        .catch(() => {});
    },
    editSubmit: function () {
      //保存
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            PutCheck(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.currentRow=null;
                this.getCheckLs();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },

  mounted() {
    this.getCheckTypes();
    this.getCheckLs();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },

  watch: {},
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
